/**
 * 门票（旅游业务部数据）
 */

import Base from './Base';


export default class Ticket extends Base {
  // doc: https://doc.oschina.net/xingchengzushou?t=158910
  schema = {
    img: String,
    title: String,
    delete_price: Number,
    price: Number,
    currency: String,
    price_suffix: String,
    goods_id: Number,
    goods_link: String,
    tags: Array,
    'sales_volume': Number
  };

  static parseInput(obj) {
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/models/Ticket.js